module.exports = __webpack_public_path__ + "static/media/gameMailDelivery.48274f94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameMailDelivery.png
// module id = 2494
// module chunks = 0